import { combineReducers, bindActionCreators } from 'redux'

import AI from './AI'
import Auth from './Auth'
import Address from './Address'
import Transaction from './Transaction'
import UI from './UI'
import Form from './Form'
import Investigation from './Investigation'
import Alert from './Alert'
import Filters from './Filters'

const actionList = {
  ...AI.actions,
  ...Auth.actions,
  ...Address.actions,
  ...Transaction.actions,
  ...UI.actions,
  ...Form.actions,
  ...Investigation.actions,
  ...Alert.actions,
  ...Filters.actions,
}

const reducerList = {
  ai: AI.reducer,
  auth: Auth.reducer,
  address: Address.reducer,
  transaction: Transaction.reducer,
  ui: UI.reducer,
  form: Form.reducer,
  investigation: Investigation.reducer,
  alert: Alert.reducer,
  filters: Filters.reducer,
}

export const reducers = combineReducers(reducerList)

export const actions = (dispatch) => ({
  actions: bindActionCreators(actionList, dispatch),
})
